<template>
  <div class="row justify-content-center pb-5">
    <div class="col-md-8">
      <p class="headline2 rowschatten p-4">
        Als erfahrenes Bau&shy;unternehmen setzen wir Ihre Projekte mit Kompetenz
        und Leidenschaft um.
      </p>
    </div>
  </div>  
  <div class="bgmain2 bildschirnansicht py-3">     
    <div class="row p-0 m-0 justify-content-center">
      <div class="col-md-3 cardCenter p-4">
        <div class="card pt-3 t-center hintergrundHell" style="width: 22rem">
          <div class="card-body p-3">
            <p class="cardHeader">Montage von leichten Trennwänden</p>
            <p class="cardHeader2">Flexibel, effizient und passgenau:</p>
            <p class="card-text pt-1 lh-base">
              Wir schaffen neue Raumstrukturen durch den Einbau moderner Leichtbauwände.
              Ob Büro, Wohnraum oder Gewerbe – unsere Trennwände passen sich Ihren
              Bedürfnissen an und bieten optimale Schalldämmung, auch als Brand- oder Einbruchschutz.
            </p>
            <p class="card-footer pt-2">
              <router-link to="/Leistungen#l1" class="nav-link noHandy">
                <span class="btn btn-outline-danger  px-3">Trennwände</span>
              </router-link>
            </p>
          </div>
        </div>
      </div>

      <div class="col-md-3 cardCenter p-4">
        <div class="card pt-3 t-center hintergrundHell" style="width: 22rem">
          <div class="card-body p-4">
            <p class="cardHeader">Design-Decken und Wände</p>
            <p class="cardHeader2">Setzen Sie architektonische Akzente:</p>
            <p class="card-text pt-1 lh-base">
              Mit unseren individuellen Decken- und Wandgestaltungen verleihen wir Ihren
              Räumen Charakter. Von eleganten Spanndecken bis zu modernen Akustikwänden –
              wir setzen Ihre Ideen stilvoll um.
            </p>
            <p class="card-footer pt-2">
              <router-link to="/Leistungen#l2" class="nav-link noHandy">
                <span class="btn btn-outline-danger  px-3">Decken und Wände</span>
              </router-link>
              
            </p>
          </div>
        </div>
      </div>

      <div class="col-md-3 cardCenter p-4">
        <div class="card pt-3 t-center hintergrundHell" style="width: 22rem">
          <div class="card-body p-4">
            <p class="cardHeader">Brandschutz&shy;verkleidung</p>
            <p class="cardHeader2">Setzen Sie architektonische Akzente:</p>
            <p class="card-text pt-1 lh-base">
              Sicherheit für Ihre Immobilie: Wir realisieren professionelle
              Brandschutzmaßnahmen nach aktuellen Normen. Unsere zertifizierten
              Brandschutzverkleidungen erhöhen den Schutz Ihrer Räume und schaffen
              Vertrauen.
            </p>
            <p class="card-footer pt-2">
              <router-link to="/Leistungen#l3" class="nav-link noHandy">
                <span class="btn btn-outline-danger  px-3">Brandschutz</span>
              </router-link>
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-3 cardCenter p-4">
        <div class="card pt-3 t-center hintergrundHell" style="width: 22rem">
          <div class="card-body p-4">
            <p class="cardHeader">Energiespartüren mit KfW-Förderung</p>
            <p class="cardHeader2">Jetzt Angebot sichern & Förderung nutzen!</p>
            <p class="card-text pt-1 lh-base">
              Senken Sie Ihre Energiekosten mit modernen Energiespartüren und sichern Sie
              sich eine KfW-Förderung von 15–20 %! <span class="extraklein">( Stand März 2025 )</span> Profitieren Sie von besserer
              Wärmedämmung, mehr Wohnkomfort und nachhaltiger Energieeffizienz.
            </p>
            <p class="card-footer pt-2">
              <router-link to="/Leistungen#l8" class="nav-link noHandy">
                <span class="btn btn-outline-danger  px-3">Türen</span>
              </router-link>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="row p-0 m-0 justify-content-center">
      <div class="col-md-3 cardCenter p-4">
        <div class="card pt-3 t-center hintergrundHell" style="width: 22rem">
          <div class="card-body p-4">
            <p class="cardHeader">Raum&shy;gestaltung</p>
            <p class="cardHeader2">Setzen Sie architektonische Akzente:</p>
            <p class="card-text pt-1 lh-base">
              Individuell und durchdacht: Wir gestalten Räume, die Ihren Ansprüchen
              entsprechen. Ob moderne Wohnkonzepte oder funktionale Arbeitsbereiche – wir
              setzen Ihre Vision in die Realität um.
            </p>
            <p class="card-footer pt-2">
              <router-link to="/Leistungen#l4" class="nav-link noHandy">
                <span class="btn btn-outline-danger  px-3">Raumgestaltung</span>
              </router-link>
            </p>
          </div>
        </div>
      </div>

      <div class="col-md-3 cardCenter p-4">
        <div class="card pt-3 t-center hintergrundHell" style="width: 22rem">
          <div class="card-body p-4">
            <p class="cardHeader">Dachausbau</p>
            <p class="cardHeader2">Mehr Raum, mehr Komfort:</p>
            <p class="card-text pt-1 lh-base">
              Nutzen Sie Ihr Dachgeschoss optimal. Wir bieten professionelle
              Dachausbau-Lösungen, die Wohnraum schaffen und gleichzeitig Energieeffizienz
              steigern.
            </p>
            <p class="card-footer pt-2">
              <router-link to="/Leistungen#l5" class="nav-link noHandy">
                <span class="btn btn-outline-danger  px-3">Dachausbau</span>
              </router-link>
            </p>
          </div>
        </div>
      </div>

      <div class="col-md-3 cardCenter p-4">
        <div class="card pt-3 t-center hintergrundHell" style="width: 22rem">
          <div class="card-body p-4">
            <p class="cardHeader">Fußböden</p>
            <p class="cardHeader2">Stilvoll und langlebig:</p>
            <p class="card-text pt-1 lh-base">
              Ob Parkett, Laminat oder Art, und Designboden – wir verlegen Fußböden, die durch
              Optik und Qualität überzeugen. Perfekt abgestimmt auf Ihre Raumgestaltung. Von Mosaikfliesen bis XXL ist alles möglich.
            </p>
            <p class="card-footer pt-2">
              <router-link to="/Leistungen#l6" class="nav-link noHandy">
                <span class="btn btn-outline-danger  px-3">Fußböden</span>
              </router-link>
            </p>
          </div>
        </div>
      </div>

      <div class="col-md-3 cardCenter p-4">
        <div class="card pt-3 t-center hintergrundHell" style="width: 22rem">
          <div class="card-body p-4">
            <p class="cardHeader">Bad&shy;sanierung</p>
            <p class="cardHeader2">Ihr Bad – modern und komfortabel:</p>
            <p class="card-text pt-1 lh-base">
              Wir verwandeln Ihr Badezimmer in eine Wohlfühloase. Von der Planung bis zur
              Fertigstellung bieten wir maßgeschneiderte Lösungen – barrierefrei, stilvoll
              und hochwertig.
            </p>
            <p class="card-footer pt-2">
              <router-link to="/Leistungen#l7" class="nav-link noHandy">
                <span class="btn btn-outline-danger  px-3">Badsanierung</span>
              </router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
